exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#results[data-v-6d905a6f] {\n  vertical-align: top;\n  margin-top: 55px;\n}\n.confidence-container[data-v-6d905a6f] {\n  max-width: 1024px;\n  text-align: left;\n}\n.confidence-table[data-v-6d905a6f] {\n  display: inline-block;\n  padding: 5px 8px;\n  text-align: left;\n  border: 1px solid grey;\n}\n.flex[data-v-6d905a6f] {\n  display: flex;\n}\n", ""]);

// exports
